Vue.config.productionTip = false

import Vue from "vue"
import axios from 'axios'
import router from './router'
import store from "./store";
import VueAxios from 'vue-axios'
import App from "./App.vue";
import Tools from './plugins/tools.js';
import Notifications from "vue-notification";
import velocity from 'velocity-animate';
import Modal from './components/Modal.vue';
import VueTheMask from 'vue-the-mask';

import './css/sass/bulma.sass';

import './css/styles.css'
import './css/transitions.css'
import './css/checkboxes.css'

Vue.config.productionTip = false;
Vue.use(Notifications, { velocity });
Vue.use(Tools);
Vue.use(VueAxios, axios);
Vue.use(VueTheMask);

Vue.component('modal', Modal);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use(config => {
    if(store.getters.getToken) {
        config.headers.common['Authorization'] = "Bearer " + store.getters.getToken;
    }
    return config;
});

axios.interceptors.response.use(response => {
    if(!response) {
        Vue.notify({
            type: 'is-danger',
            text: 'Wystąpił błąd połączenia z serwerem.'
        });
        return;
    }

    store.commit("SET_TOKEN_VALID");
    
    return response;
}, error => {
    if(!error.response) {
        Vue.notify({
            type: 'is-danger',
            text: 'Wystąpił błąd połączenia z serwerem.'
        });
        return Promise.reject(error);
    }
    if(error.response.status == 401) {
        store.commit("SET_TOKEN_INVALID");
        return error;
    }
    else if(error.response.status == 403) {
        Vue.notify({
            type: 'is-danger',
            text: 'Niestety nie masz dostępu do tej części Viessmann PRO.'
        })
    }
    return Promise.reject(error);
});


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#viessmann-accounts-app')
